import React, { useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Home, OfferGenerator, PageNotFound, PriceModelB } from './pages';
import { Navbar, Footer, Popup, WaitlistForm } from './components';
import { iconBg } from './assets';
import './App.css';

const App = () => {
  const [showForm, setShowForm] = useState(false);

  // Helper Functions

  const navClick = (url) => {
    window.open(url)
  };

  const handleForm = () => {
      setShowForm(!showForm)
  };

  // The Offer Generator is a standalone internal tool: it is intentionally not
  // linked anywhere on the marketing site and renders without the public
  // Navbar/Footer chrome.
  const location = useLocation();
  const isStandalone = location.pathname.startsWith('/offer-generator');

  if (isStandalone) {
    return (
      <Routes>
        <Route path="/offer-generator" element={<OfferGenerator />} />
      </Routes>
    );
  }

  // Main Site Structure

  return (
    <div className="App">

      <Navbar handleForm={handleForm} navClick={navClick} />

      <main
        style={{
          backgroundImage: `url(${iconBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right bottom"
        }}
      >
        <Routes>
          <Route path="/" element={<Home handleForm={handleForm} navClick={navClick} />} />
          {/* Multi-platform (YouTube/IG/TikTok) calculator with email-delivered
              results. It replaced the original YouTube-only synchronous tool
              (PriceModel.js, no longer routed) at this path. */}
          <Route path="/price-model" element={<PriceModelB />} />
          {/* It was served at /price-model-b first, and results emails sent
              then link there: keep those working, ?run=<uid> included. */}
          <Route
            path="/price-model-b"
            element={
              <Navigate
                to={{ pathname: '/price-model', search: location.search, hash: location.hash }}
                replace
              />
            }
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </main>

      <Footer />

      <Popup trigger={showForm} onClose={handleForm}>
        <WaitlistForm />
      </Popup>

    </div>
  );
};

export default App;
